const ConfigConstants = {
  consulServiceName: 'acesvcs',
  nodeConfigServiceName: 'ace',
  externalEndpoint: '/pws/v1/ace/',
  internalEndpoint: '/seti-svcs/ace/v1/',
  baseImpressionUrl: 'impression/',
  baseEventUrl: 'event/',
}

export default ConfigConstants
